"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const static_html_js_1 = require("lit/static-html.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
const flexAlignItemsTokens = {
    center: { 'align-items': 'center' },
    'flex-start': { 'align-items': 'flex-start' },
    'flex-end': { 'align-items': 'flex-end' },
    baseline: { 'align-items': 'baseline' },
};
/**
 * 범용 flexbox 레이아웃 프리미티브.
 * 의미별 그룹핑(button/tag/avatar 등)은 각 시멘틱 컴포넌트가 담당하고,
 * mm-flex 는 순수 레이아웃만 책임진다.
 *
 * 레이아웃은 reflect된 attribute를 받는 :host 셀렉터로만 적용한다(인라인 스타일 없음).
 * 기본(as="div")은 host 자체가 flex 컨테이너다. 시멘틱 랜드마크가 필요한 경우(as="section" 등)에만
 * 내부 요소를 컨테이너로 쓰며, 레이아웃 값은 host 계산값에 남아 있어 `inherit`으로 그대로 내려간다.
 */
let Flex = class Flex extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.direction = 'row';
        this.justifyContent = 'flex-start';
        this.alignItems = 'stretch';
        this.gap = '0';
        this.as = 'div';
        this.wrap = 'nowrap';
        this.stretch = false;
    }
    render() {
        if (this.as === 'div') {
            return (0, static_html_js_1.html) `
        <slot></slot>
      `;
        }
        const tag = (0, static_html_js_1.unsafeStatic)(this.as);
        // eslint-disable-next-line lit/binding-positions, lit/no-invalid-html -- lit/static-html의 태그 자리 바인딩이라 정상이다.
        return (0, static_html_js_1.html) `<${tag} class="flex"><slot></slot></${tag}>`;
    }
    /** 기본 as="div"의 group role은 host attribute로 반영한다. */
    willUpdate() {
        if (this.as === 'div') {
            this.setAttribute('role', 'group');
            return;
        }
        this.removeAttribute('role');
    }
};
Flex.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        --flex-gap: 0;

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        gap: var(--flex-gap);
      }

      /* 시멘틱 래퍼를 쓰는 경우 host는 단순 박스이고 내부 .flex가 flex 컨테이너다. */
      :host([as='header']),
      :host([as='section']),
      :host([as='footer']),
      :host([as='nav']) {
        display: block;
      }

      :host([direction='column']) {
        flex-direction: column;
      }

      :host([wrap='wrap']) {
        flex-wrap: wrap;
      }
      :host([wrap='wrap-reverse']) {
        flex-wrap: wrap-reverse;
      }

      ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('justify-content', shared_styles_1.justifyContentTokens))}

      ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('align-items', flexAlignItemsTokens))}

      ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('gap', (0, shared_styles_1.spaceTokens)('--flex-gap')))}

      :host([stretch]) ::slotted(*) {
        flex: 1;
      }

      .flex {
        display: flex;
        flex-direction: inherit;
        justify-content: inherit;
        align-items: inherit;
        flex-wrap: inherit;
        gap: inherit;
        width: 100%;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Flex.prototype, "direction", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'justify-content', reflect: true })
], Flex.prototype, "justifyContent", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'align-items', reflect: true })
], Flex.prototype, "alignItems", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Flex.prototype, "gap", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Flex.prototype, "as", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Flex.prototype, "wrap", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], Flex.prototype, "stretch", void 0);
Flex = __decorate([
    (0, decorators_js_1.customElement)('mm-flex')
], Flex);
exports.Flex = Flex;
//# sourceMappingURL=data:application/json;base64,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